export default {
  // Campaigns
  campaigns: {
    title: 'Reward Campaigns',
    subtitle: 'Manage loyalty and reward campaigns for your tenants',
    new_button: 'New Campaign',
    status: {
      draft: 'Draft',
      active: 'Active',
      paused: 'Paused',
      closed: 'Closed',
    },
    earn_model: {
      stamp: 'Stamp Card',
      points: 'Points',
      instant: 'Instant Reward',
    },
    fields: {
      name: 'Campaign Name',
      description: 'Description',
      earn_model: 'Earn Model',
      status: 'Status',
      property: 'Property',
      pool_remaining: 'Remaining Pool',
      pool_total: 'Total Pool',
      partner_shops_count: 'Partner Shops',
      catalog_items_count: 'Catalog Items',
      starts_at: 'Starts At',
      ends_at: 'Ends At',
      published_at: 'Published At',
    },
    publish_panel: {
      title: 'Publish & Fund Campaign',
      description: 'Fund the reward pool and activate this campaign.',
      funded_amount: 'Funded Amount (THB)',
      subsidy_amount: 'Subsidy Amount (THB)',
      starts_at: 'Campaign Start Date',
      ends_at: 'Campaign End Date',
      publish_button: 'Publish & Fund',
      pool_info: 'Pool: {{remaining}} / {{total}} THB remaining',
    },
    form: {
      save_button: 'Save Campaign',
      create_success: 'Campaign created.',
      update_success: 'Campaign updated.',
      publish_success: 'Campaign published and funded.',
      delete_confirm: 'Delete this campaign? This cannot be undone.',
      delete_success: 'Campaign deleted.',
    },
    empty: {
      title: 'No campaigns yet',
      description: 'Create a reward campaign to start engaging your tenants.',
    },
  },

  // Partner Shops
  partner_shops: {
    title: 'Partner Shops',
    new_button: 'Add Shop',
    fields: {
      name: 'Shop Name',
      contact_name: 'Contact Name',
      phone: 'Phone',
      tax_id: 'Tax ID',
      address: 'Address',
      status: 'Status',
      devices: 'Devices',
      last_used_at: 'Last Used',
      session_expires_at: 'Session Expires',
    },
    actions: {
      revoke: 'Revoke Session',
      rotate: 'Rotate Token',
      revoke_confirm: 'Revoke the active device session for this shop?',
      revoke_success: 'Session revoked.',
      rotate_success: 'Token rotated.',
    },
    token_panel: {
      title: 'New Session Token',
      description: 'Copy this token now. It will not be shown again.',
      device_label: 'Device Label',
    },
    form: {
      save_button: 'Save Shop',
      create_success: 'Shop added.',
      update_success: 'Shop updated.',
      delete_confirm: 'Delete this shop? This cannot be undone.',
      delete_success: 'Shop deleted.',
    },
    empty: {
      title: 'No partner shops yet',
      description: 'Add partner shops to this campaign.',
    },
  },

  // Catalog
  catalog: {
    title: 'Reward Catalog',
    subtitle: 'Manage redeemable rewards across all campaigns',
    new_button: 'New Item',
    reward_type: {
      partner_voucher: 'Partner Voucher',
      rent_credit: 'Rent Credit',
      flowrent_perk: 'FlowRent Perk',
      instant_discount: 'Instant Discount',
    },
    fields: {
      name: 'Item Name',
      reward_type: 'Reward Type',
      cost_points: 'Cost (Points)',
      thb_value: 'THB Value',
      funding: 'Funding',
      stock: 'Stock',
      per_customer_limit: 'Per Customer Limit',
      active: 'Active',
      campaign: 'Campaign',
    },
    form: {
      save_button: 'Save Item',
      create_success: 'Catalog item created.',
      update_success: 'Catalog item updated.',
      delete_confirm: 'Delete this catalog item? This cannot be undone.',
      delete_success: 'Catalog item deleted.',
    },
    empty: {
      title: 'No catalog items yet',
      description: 'Add rewards to the catalog for tenants to redeem.',
    },
  },

  // Promotions
  promotions: {
    title: 'Promotions',
    subtitle: 'Manage discount promotions and track redemptions',
    new_button: 'New Promotion',
    kind_label: 'Kind',
    value_type: {
      fixed: 'Fixed',
      percent: 'Percent',
    },
    fields: {
      kind: 'Promotion Kind',
      value_type: 'Value Type',
      value: 'Value',
      currency: 'Currency',
      funding: 'Funding',
      starts_at: 'Starts At',
      ends_at: 'Ends At',
      max_redemptions: 'Max Redemptions',
      per_customer_limit: 'Per Customer Limit',
      status: 'Status',
      redemptions_count: 'Redemptions',
      conditions: 'Conditions',
      code: 'Promo Code (optional)',
    },
    status: {
      active: 'Active',
      draft: 'Draft',
      paused: 'Paused',
      expired: 'Expired',
      ended: 'Ended',
    },
    redemptions: {
      title: 'Redemptions',
      customer_id: 'Customer ID',
      lease_id: 'Lease ID',
      invoice_id: 'Invoice ID',
      amount: 'Amount',
      applied_amount: 'Applied Amount',
      status: 'Status',
      redeemed_at: 'Redeemed At',
      empty_title: 'No redemptions yet',
      empty_description: 'Redemptions will appear here when tenants use this promotion.',
      status_values: {
        eligible: 'Eligible',
        applied: 'Applied',
        void: 'Void',
      },
    },
    form: {
      save_button: 'Save Promotion',
      create_success: 'Promotion created.',
      update_success: 'Promotion updated.',
      delete_confirm: 'Delete this promotion? This cannot be undone.',
      delete_success: 'Promotion deleted.',
    },
    empty: {
      title: 'No promotions yet',
      description: 'Create a promotion to offer discounts to tenants.',
    },
  },
}
